import React, { FC, memo, useEffect, useMemo, useState } from "react";
import { Col, Row } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AppNavigation from "@components/AppNavigation";
import AppButton from "@components/AppButton";
import { ReactComponent as SuccessFull } from "@components/Icons/success.svg";

import {
  ResetPasswordFormValue,
  CollapseData,
  ResetPasswordStatusName,
} from "@pages/reset-password/model";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/store/configureStore";
import { setTitle } from "src/store/State";
import { MessageType } from "src/models/common.model";
import Collapse from "../Collapse";

interface Props {
  value?: ResetPasswordFormValue;
}

const Success: FC<Props> = memo(({ ...props }) => {
  const { value } = props;

  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const [clientUrl, setClientUrl] = useState<any>();
  const [webDomain, setWebDomain] = useState<any>();
  const [urlFAQ, setUrlFAQ] = useState<any>();
  const systemConfig = useSelector(
    (state: RootState) => state.GlobalReducer.systemConfig
  );
  const isApp = (window as any).ReactNativeWebView;

  useEffect(() => {
    setClientUrl(systemConfig.find((item) => item.key === "ClientUrl"));
    // setWebDomain(systemConfig.find((item) => item.key === "WebDomain"));
    setWebDomain('info@mashipla.com');
    setUrlFAQ(systemConfig.find((item) => item.key === "FAQ"));
  }, [systemConfig]);

  const items: CollapseData[] = useMemo(
    () => [
      // {
      //   title: t("signup.success.collapse1.title"),
      //   content: (
      //     <div>
      //       {t("signup.success.collapse1.text1")}
      //       <span
      //         onClick={() => navigate("/reset-password")}
      //         style={{ color: "#FF671E", cursor: "pointer" }}
      //       >
      //         {t("signup.success.collapse1.text2")}
      //       </span>
      //       {t("signup.success.collapse1.text3")}
      //     </div>
      //   ),
      // },
      {
        title: t("signup.success.collapse2.title"),
        content: (
          <div>
            <span style={{ color: "#FF671E" }}>
              {!isApp ? (
                  webDomain
              ) : (
                <span
                  onClick={() => {
                    if (clientUrl) {
                      const message = {
                        type: MessageType.MODAL,
                        data: clientUrl?.value,
                      };
                      (window as any).ReactNativeWebView.postMessage(
                        JSON.stringify(message)
                      );
                    }
                  }}
                >
                  {webDomain}
                </span>
              )}
            </span>
            {t("signup.success.collapse2.text2")}
          </div>
        ),
      },
      {
        title: t("signup.success.collapse3.title"),
        content: (
          <div>
            {t("signup.success.collapse3.text1")}
            <span style={{ color: "#FF671E" }}>
              {!isApp ? (
                <a href={urlFAQ?.value} target="_blank" rel="noreferrer">
                  {t("signup.success.collapse3.text2")}
                </a>
              ) : (
                <span
                  onClick={() => {
                    if (urlFAQ) {
                      const message = {
                        type: MessageType.MODAL,
                        data: urlFAQ?.value,
                      };
                      (window as any).ReactNativeWebView.postMessage(
                        JSON.stringify(message)
                      );
                    }
                  }}
                >
                  {t("signup.success.collapse3.text2")}
                </span>
              )}
            </span>
            {t("signup.success.collapse3.text3")}
          </div>
        ),
      },
      {
        title: t("signup.success.collapse4.title"),
        content: <div>{t("signup.success.collapse4.text")}</div>,
      },
    ],
    [urlFAQ, clientUrl]
  );

  const backLogin = () => {
    navigate("/login");
  };

  useEffect(() => {
    dispatch(setTitle(ResetPasswordStatusName.SENT_EMAIL));
    return () => {
      dispatch(setTitle(""));
    };
  }, []);

  return (
    <div className="ui-reset-password-success">
      <AppNavigation title={t("resetPassword.success.pageTitle")} />
      <div className="ui-reset-password-success__content">
        <Row gutter={[32, 32]} justify="center">
          <Col xs={24} md={12} xl={24}>
            <div className="ui-reset-password-success__icon">
              <SuccessFull />
            </div>
            <h5 className="ui-reset-password-success__title">
              {t("signup.success.title")}
            </h5>
            <p className="ui-reset-password-success__description">
              「{value?.emailAddress}」
              {t("resetPassword.result.success.description")}
            </p>
            {items &&
              items.length &&
              items.map(({ title, content }, index) => (
                <Collapse key={index} title={title} content={content} />
              ))}
          </Col>
        </Row>
      </div>

      <div className="ui-reset-password-success__action">
        <Row gutter={[48, 48]} justify="center">
          <Col xs={24} md={12} xl={8}>
            <AppButton buttontype="primary" onClick={backLogin}>
              {t("signup.success.exit")}
            </AppButton>
          </Col>
        </Row>
      </div>
    </div>
  );
});

export default Success;
